import { useMemo } from 'react';
import { FdsIcon, FdsIconType } from '@tcc/fds';
import { getMessage } from '@tcc/i18n';
import { getOtcPurchaseUrl, getOtcUpgradeUrl } from '@tcc/web-otc-entry';
import { ImpersonationMode } from '../types/impersonationModes';
import { UrlPlaceholders } from './useNavigationLinks/types';

export type SubMenuDescriptor = {
  label: string;
  leadingIcon?: FdsIconType;
  testId?: string;
  id?: string;
  href: string;
  queryParams?: Record<string, string>;
  excludedImpersonationModes?: ImpersonationMode[];
  requiredFeatureFlags?: string[];
  excludedByFeatureFlag?: string[];
};

interface UseSubMenuDescriptorsParams {
  countryCode?: string;
  isCommerceCloudEnabled?: boolean;
}

export const useSubMenuDescriptors = ({
  countryCode = '',
  isCommerceCloudEnabled = false,
}: UseSubMenuDescriptorsParams = {}) => {
  const descriptors = useMemo<SubMenuDescriptor[]>(() => [
    {
      label: getMessage('sidenav.manageAccount'),
      testId: 'information-architecture-manage-account',
      leadingIcon: FdsIcon.Settings,
      id: 'settings',
      href: `${UrlPlaceholders.ROOT_URL}/static/field-view/#/settings/${UrlPlaceholders.QUERY_PARAMS}`,
      excludedImpersonationModes: [ImpersonationMode.DEALER_PROXYING_FARMER],
      requiredFeatureFlags: ['web.settings-plugin-version'],
    },
    {
      label: getMessage('sidenav.manageAccount'),
      testId: 'information-architecture-manage-account',
      leadingIcon: FdsIcon.Settings,
      id: 'settings-legacy',
      href:  `${UrlPlaceholders.ROOT_URL}/static/settings/index.html${UrlPlaceholders.QUERY_PARAMS}`,
      excludedImpersonationModes: [ImpersonationMode.DEALER_PROXYING_FARMER],
      excludedByFeatureFlag: ['web.settings-plugin-version'],
    },
    {
      label: getMessage('sidenav.order'),
      testId: 'information-architecture-order',
      leadingIcon: FdsIcon.ShoppingCartCheckout,
      id: 'order',
      href: getOtcUpgradeUrl({
        isCommerceCloudEnabled,
        countryCode,
        operationId: 'nooperation'
      }),
      requiredFeatureFlags: ['farmer-navigation.isCommerceCloudEnabled']
    },
    {
      label: getMessage('sidenav.order'),
      testId: 'information-architecture-order',
      leadingIcon: FdsIcon.ShoppingCartCheckout,
      id: 'order',
      href: getOtcPurchaseUrl({
        isCommerceCloudEnabled,
        operationId: 'nooperation'
      }),
      excludedByFeatureFlag: ['farmer-navigation.isCommerceCloudEnabled']
    },
    {
      label: getMessage('sidenav.logOut'),
      testId: 'information-architecture-logout',
      leadingIcon: FdsIcon.Logout,
      id: 'logout',
      href: `${UrlPlaceholders.ROOT_URL}/static/field-view/#/auth/logout/${UrlPlaceholders.QUERY_PARAMS}`,
    },
  ], [countryCode, isCommerceCloudEnabled]);

  return descriptors;
};
